import { render, staticRenderFns } from "./ByCategory.vue?vue&type=template&id=2c420fae&"
import script from "./ByCategory.vue?vue&type=script&lang=js&"
export * from "./ByCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports